import styled from 'styled-components';
import Link from 'next/link';

export const StandardLink = styled.a`
  color: ${({ theme }) => theme.colors.primary.default};
  text-decoration: underline;
`;

export const NextLink = styled(Link)`
  color: ${({ theme }) => theme.colors.primary.default};
  text-decoration: underline;
`;
